import React from 'react';
import Modal from 'react-bootstrap/Modal';
import '../../lib/css/DarkModal.css';

/**
 * Base modal component that provides common modal structure
 * @param {Object} props
 * @param {boolean} props.show - Whether the modal is visible
 * @param {Function} props.onHide - Function to call when modal should be closed
 * @param {string} props.title - Modal title
 * @param {React.ReactNode} props.children - Modal body content
 * @param {React.ReactNode} props.footer - Modal footer content (optional)
 * @param {string} props.size - Modal size (sm, lg, xl) (optional)
 * @param {string} props.className - Additional CSS classes (optional)
 * @param {boolean} props.closeButton - Show close button in header (default: true)
 */
const BaseModal = ({
    show,
    onHide,
    title,
    children,
    footer,
    size,
    className = '',
    closeButton = true
}) => {
    return (
        <Modal 
            show={show} 
            onHide={onHide} 
            className={`modal-dark ${className}`}
            size={size}
        >
            {title && (
                <Modal.Header closeButton={closeButton}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body>
                {children}
            </Modal.Body>
            {footer && (
                <Modal.Footer>
                    {footer}
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default BaseModal;

